import React, { useEffect, useState } from "react";
import useApi from "../utils/UseAPI";
import Spinner from "react-bootstrap/Spinner";
import SanitizeHref from "../utils/SanitizeHref";

function PBForms() {
  const { error, processing, getRequest } = useApi();
  const [allForms, setAllForms] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      // Note: Updated sfy to 2026 as per your snippet
      const [data, status] = await getRequest(null, "form/dpr-pb/pb?sfy=2026");
      if (status === 200) {
        setAllForms(data.data.pb);
      } else {
        // console.log(error);
      }
    };
    fetchLinks();
  }, [error]);

  return (
    <div className="container py-4">
      <h2 id="all-forms-by-number" className="mb-4 border-bottom pb-2">
        All Forms By Number
      </h2>

      {processing ? (
        <div className="text-center p-5" role="status" aria-live="polite">
          <Spinner animation="border" variant="success" />
          <span className="visually-hidden">Loading forms...</span>
          <p className="mt-2 text-muted">Loading forms...</p>
        </div>
      ) : (
        <ul className="row g-3 list-unstyled">
          {allForms.map((data, index) => (
            <li key={index} className="col-12 col-md-6 col-lg-4">
              <div className="quick-links-body h-100">
                <a
                  href={SanitizeHref(
                    `documents/cmhc/pb/${data.formName}${data.formExtention}`,
                  )}
                  className="d-flex align-items-center p-3 text-decoration-none border rounded h-100 hover-shadow bg-light"
                  title={`Download ${data.formName}`}
                >
                  <span className="me-3 fs-4" aria-hidden="true">
                    📄
                  </span>
                  <div className="d-flex flex-column">
                    <span className="fw-bold text-primary">
                      {data.formName}
                    </span>
                    <span className="small text-muted">Download Document</span>
                  </div>
                </a>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PBForms;
